module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/media-folder-b859a034af0344df58d50c4f6524a4e7.svg";